import { isFunction, removeChar } from 'coreutils-js';
import { useEffect, useState } from "react";

// import { useParams } from 'react-router-dom';
const useFilterParams = (config?: string[]) => {
  const [param, setParam] = useState({});
  useEffect(() => {
    getParams();
  }, [window.location.search]);


  const getParams = () => {
    const p = searchToObject();
    setParam(p);
  }

  const setParams = (data) => {
    if (!isFunction(data)) {
      setParamsUrl(data);
    } else {
      setParamsUrl(data(param));
    }
    getParams();
  }

  return {
    params: param,
    setParams,
  }
}

function searchToObject() {
  let pairs = window.location.search.substring(1).split("&"),
    obj = {},
    pair,
    i;

  for (i in pairs) {
    if (pairs[i] === "") continue;

    pair = pairs[i].split("=");
    obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  return obj;
}


export function setParamsUrl(params = {}, config = {
  replace: false,
}, basename = '') {
  if (config.replace) {
    window.history.pushState(
      {},
      undefined,
      "/" + nomarlizePath(`${basename}/${location.pathname}${params && serialize(params)}`)
    );
  } else {
    window.history.pushState(
      {},
      undefined,
      "/" + nomarlizePath(`${basename}/${location.pathname}${params && serialize({ ...searchToObject(), ...params })}`)
    );
  }
}

export const nomarlizePath = function (path) {
  let fix_path = path.replace(/\/{1,}/g, "/");
  fix_path = removeChar(fix_path, "/", "begin_end_all");
  return fix_path;
};

function serialize(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return '?' + str.join("&");
}


export default useFilterParams;